var _rect, _rect2, _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 43,
    height: 43,
    rx: 9.5,
    fill: "#F283B6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 43,
    height: 43,
    rx: 9.5,
    stroke: "#382F5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 20.9167C13.5 17.7191 13.5 16.1203 13.8775 15.5824C14.255 15.0445 15.7583 14.53 18.7649 13.5008L19.3377 13.3047C20.905 12.7682 21.6886 12.5 22.5 12.5C23.3114 12.5 24.095 12.7682 25.6623 13.3047L26.2351 13.5008C29.2417 14.53 30.745 15.0445 31.1225 15.5824C31.5 16.1203 31.5 17.7191 31.5 20.9167C31.5 21.3996 31.5 21.9234 31.5 22.4914C31.5 28.1294 27.261 30.8655 24.6014 32.0273C23.88 32.3424 23.5193 32.5 22.5 32.5C21.4807 32.5 21.12 32.3424 20.3986 32.0273C17.739 30.8655 13.5 28.1294 13.5 22.4914C13.5 21.9234 13.5 21.3996 13.5 20.9167Z",
    stroke: "#0D1B2A",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 18.5V22.5",
    stroke: "#0D1B2A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 25.5,
    r: 0.5,
    fill: "#1A1A1A",
    stroke: "#0D1B2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.0cbe71b03a1de75cdb32a538f141e4d5.svg";
export { ForwardRef as ReactComponent };